import MealPopularIcon from "./MealPopularIcon";

const MealPopular = () => {
  return (
    <span className="Meal-popular">
      <MealPopularIcon /> Populaire
    </span>
  );
};

export default MealPopular;
